import { createRouter } from "@tanstack/react-router";
import type { AuthContextProps } from "oidc-react";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: {
    // Populated by <App /> once oidc-react has resolved the session.
    auth: undefined! as AuthContextProps
  },
  basepath: "/membersapp",
  defaultPreload: "intent",
  scrollRestoration: true
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
